import { useEffect, useState } from 'react';
import CustomLayout from '../components/custom-layout';
import Starfield from '../backgrounds/starfield';
import IconEmail from '../vectors/icon-email';
import IconLinkedIn from '../vectors/icon-linked-in';
import IconPhone from '../vectors/icon-phone';
import CC from '../scripts/combine-classes';
import classes from './home.module.css';

const Home = () => {
  const [offScreen, setOffScreen] = useState(true);

  useEffect(() => {
    setOffScreen(false);
  }, []);

  return (
    <CustomLayout
      align="centre"
      background={<Starfield />}
    >
      <div className={CC(
        classes.container,
        { [classes.adjust]: offScreen },
      )}>
        <h1 className={CC(
          classes.h1,
          { [classes.adjust]: offScreen },
        )}>
          <span>Damien</span><span>Watson</span>
        </h1>
      
        <p className={CC(
          classes.byline,
          { [classes.adjust]: offScreen },
        )}>
          Software Engineer
        </p>
        
        <p className={CC(
          classes.summary,
          { [classes.adjust]: offScreen },
        )}>
          I started creating graphics and animation and even coding, back in the dark ages before the net. I was
          fascinated by what you could achieve with 32 colours and a 320 x 256 pixel screen. Fast forward to today
          and I still have the same passion and drive to see what can be done.<br /><br />

          A deep focus, high attention to detail, a strong sense of innovation and adaptability have guided
          my career journey; from early work in desktop publishing, graphic design, motion graphics and 3D modeling,
          to design and web development, mobile and IoT solutions, UI design, and software engineering.
        </p>

        <div className={classes.links}>
          <a
            href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#100;&#97;&#109;&#105;&#101;&#110;&#115;&#105;&#110;&#98;&#111;&#120;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;"
            rel="noreferrer"
            target="_blank"
            className={classes.link}
          >
            <span className={CC(
              classes.emailIcon,
              { [classes.adjust]: offScreen },
            )}>
              <IconEmail />
            </span>
            <span className={CC(
              classes.iconText,
              { [classes.adjust]: offScreen },
            )}>
              &#100;&#97;&#109;&#105;&#101;&#110;&#115;&#105;&#110;&#98;&#111;&#120;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;
            </span>
          </a>

          <a
            href="&#116;&#101;&#108;&#58;&#43;&#54;&#49;&#32;&#48;&#52;&#49;&#55;&#51;&#55;&#51;&#57;&#53;&#49;"
            rel="noreferrer"
            target="_blank"
            className={classes.link}
          >
            <span className={CC(
              classes.emailIcon,
              { [classes.adjust]: offScreen },
            )}>
              <IconPhone />
            </span>
            <span className={CC(
              classes.iconText,
              { [classes.adjust]: offScreen },
            )}>
              &#43;&#54;&#49;&#32;&#48;&#52;&#49;&#55;&#51;&#55;&#51;&#57;&#53;&#49;
            </span>
          </a>

          <a
            href="https://www.linkedin.com/in/damien-watson-2279b0/"
            rel="noreferrer"
            target="_blank"
            className={classes.link}
          >
            <span className={CC(
              classes.liIcon,
              { [classes.adjust]: offScreen },
            )}>
              <IconLinkedIn />
            </span>
          </a>
        </div>
      </div>
    </CustomLayout>
  );
};

// 
export default Home;